import { ConversationMarkStateModel } from 'src/core/models/conversation/conversation-mark.state-model';

export class DataChange {
    static readonly type = '[ConversationMark] DataChange';

    constructor(public payload: ConversationMarkStateModel) { }
}